// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoReview_root__Akfco","shadowTitle":"VideoReview_shadowTitle__g6gAm","title":"VideoReview_title__ul7h_","card_container":"VideoReview_card_container__egLs1"};